import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import 'iconify-icon';
import { useGlobalWaLink } from '../contexts/SettingsContext';

const WhatsAppFloat = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const waHref = useGlobalWaLink(t('whatsapp_float.prefill_message'));

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 120);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (location.pathname.startsWith('/admin')) return null;

  return (
    <a
      href={waHref}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('whatsapp_float.cta')}
      data-testid="whatsapp-float-btn"
      className={`group fixed bottom-6 right-6 z-50 flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-2xl shadow-emerald-900/30 hover:shadow-emerald-900/50 transition-all duration-300 transform ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0 pointer-events-none'
      } hover:scale-105 active:scale-95`}
    >
      <span className="relative flex items-center justify-center w-9 h-9 rounded-full bg-white/15">
        <span className="absolute inset-0 rounded-full bg-white/20 animate-ping"></span>
        <iconify-icon
          icon="mdi:whatsapp"
          className="text-3xl text-white relative z-10"
        ></iconify-icon>
      </span>
      <span className="hidden sm:flex flex-col leading-tight">
        <span className="text-[10px] font-mono uppercase tracking-widest opacity-90">{t('whatsapp_float.label')}</span>
        <span className="text-sm font-semibold">{t('whatsapp_float.cta')}</span>
      </span>
    </a>
  );
};

export default WhatsAppFloat;
